import { StoreFinish } from "@/components/StoreComponents/StoreFinish";
import FlowContainer from "../../components/FlowContainer";
import RewardFlowFinishButtons from "../../components/RewardFlowFinishButtons";
import { useSiteBrandingType } from "@/components/SiteProvider";
import { SiteBrandingType } from "@/types/misc";

const Finish = ({ product }: { product: any }) => {
  const brandName = product?.brandName;
  const brandId = product?.brandId;
  const siteBrandingType = useSiteBrandingType();
  const isDTC = siteBrandingType === SiteBrandingType.CustomDTCStore;

  return (
    <FlowContainer>
      <StoreFinish
        title="Thank you"
        subtitle="We're working on sending your review to the retailer."
        confettiProps={{ brandId: isDTC ? brandId : undefined }}
      >
        <RewardFlowFinishButtons
          brandName={brandName}
          brandId={brandId}
          solidButtonSxStyles={{ marginTop: "10px" }}
        />
      </StoreFinish>
    </FlowContainer>
  );
};

export default Finish;
